import { Navbar } from "@/components/layout/Navbar"
import { Footer } from "@/components/layout/Footer"
import { Hero } from "@/components/sections/Hero"
import { TrustBar } from "@/components/sections/TrustBar"
import { HowItWorks } from "@/components/sections/HowItWorks"
import { HowItWorksTiltedGrid } from "@/components/sections/HowItWorksTiltedGrid"
import { LiveTradeCommandCenter } from "@/components/sections/LiveTradeCommandCenter"

import { TradeIntelligenceDashboard } from "@/components/sections/TradeIntelligenceDashboard"
import { RoleCards } from "@/components/sections/RoleCards"
import { SupplierSteps } from "@/components/sections/SupplierSteps"
import { FinalCTA } from "@/components/sections/FinalCTA"

export function HomePage() {
  return (
    <div className="min-h-screen bg-white flex flex-col text-slate-900">
      {/* Full-Width Header Bar */}
      <Navbar />

      <main className="flex-grow">
        {/* 1. Hero with interactive AI matching pills and live streaming ticker */}
        <Hero />
        
        {/* 2. Platform Trust Signals */}
        {/* <TrustBar /> */}

        {/* Unified Intelligence & Sourcing Suite */}
        <div className="relative bg-white text-slate-900 overflow-hidden">
          {/* Continuous Shared Grid Background across LiveTradeCommandCenter, PanIndiaNetwork, and HowItWorks */}
          {/* <div 
            className="absolute inset-0 opacity-[0.22] pointer-events-none"
            style={{
              backgroundImage: `
                linear-gradient(var(--outline-variant) 1px, transparent 1px),
                linear-gradient(90deg, var(--outline-variant) 1px, transparent 1px)
              `,
              backgroundSize: "44px 44px"
            }}
          /> */}

          {/* Continuous Ambient Atmospheric Glows */}
          <div className="absolute -left-24 top-[15%] w-[500px] h-[500px] rounded-full bg-primary/5 blur-[140px] pointer-events-none" />
          <div className="absolute -right-24 top-[50%] w-[520px] h-[520px] rounded-full bg-blue-500/5 blur-[140px] pointer-events-none" />
          <div className="absolute -left-24 top-[82%] w-[500px] h-[500px] rounded-full bg-primary/5 blur-[140px] pointer-events-none" />

          {/* 3. Live B2B Command Center: KPIs, Sparklines & Supply/Demand Capacity Meters */}
          <LiveTradeCommandCenter />




          {/* 7. Trade Intelligence Dashboard: Top Exports Bar Chart & Category Share Donut */}
          {/* <TradeIntelligenceDashboard /> */}

          {/* 8. Sourcing Process Workflow */}
          {/* <HowItWorks /> */}

          {/* 8b. Alternative Layout Comparison (Tilted Cylindrical Stream) */}
          <HowItWorksTiltedGrid />
        </div>

        {/* 9. Supplier Selling Workflow (Start Selling in Just a Few Steps) */}
        <SupplierSteps />

        {/* 10. Buyer vs. Supplier Role Selector */}
        {/* <RoleCards /> */}

        {/* 11. High-Conversion Final CTA */}
        <FinalCTA />
      </main>

      <Footer />
    </div>
  )
}
